import React, { useState, useEffect } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "assets/svgIcons/AccordionExpandMoreIcon";
import CustomizedCheckbox from "commonComponents/FormElement/Checkbox";
import {
    getFeatureSetOption,
    getFeaturesList,
    isUserBasic,
    isUserReadOnly
} from "../../../../constant";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import {
    Heading,
    WorkSection,
    CheckBoxWrapper,
    ActionWrapper,
    StartEndDate,
    DateWrapper,
    UnlockModeWrapper,
    UnlockMode
} from "pages/Fleet/Settings/SettingsStyled";
import { Loader } from "commonComponents/Loader/Loader";
import { useHookstate } from "@hookstate/core";
import { CenteredLoader } from "commonComponents/FormElement/Checkbox/CheckboxStyled";
import { FLEET_GLOBAL_STATES, SITEID_GLOBAL_STATE, CHECKBOX_LOADER, ADS_GLOBAL_STATE } from "globalStore/globalStore";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Button } from "@mui/material";
import "react-quill/dist/quill.snow.css";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import TextField from "@mui/material/TextField";
import TimeIcon from "assets/svgIcons/TimeIcon";

export const ScheduledFleetLockdownAccordion = ({ schedLockdownSaveButton,
    setSchedLockdownSaveButton
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
    const { FleetLockdownLoader } = useHookstate(CHECKBOX_LOADER);
    const { enableDisableLockdownState } = useHookstate(FLEET_GLOBAL_STATES);
    const { alertMsg, redirectState } = useHookstate(ADS_GLOBAL_STATE);

    const {
        siteSettingsData,
        getUserRole,
        getScheduledFleetLockdownData
    } = useSelector((state) => state?.commonReducers) || [];

    const [scheduledFleetLockdown, setScheduledFleetLockdown] = useState({
        sflEnableLockdown: false,
        sflStartTime: new Date(2000, 0, 1, 0, 0, 0),
        sflEndTime: new Date(2000, 0, 1, 0, 0, 0),
        sflUnlockMode: "normal",
    });
    const [schedLockdownValidationMessage, setSchedLockdownValidationMessage] = useState("");

    useEffect(() => {
        if (getScheduledFleetLockdownData && Object.keys(getScheduledFleetLockdownData)?.length > 0 && siteSettingsData && Object.keys(siteSettingsData).length !== 0 && !_.isNull(siteSettingsData?.TimeZoneOffset)) {
            var startDt = moment.utc(getScheduledFleetLockdownData?.StartTimeInUtc).utcOffset(-siteSettingsData.TimeZoneOffset);
            var endDt = moment.utc(getScheduledFleetLockdownData?.EndTimeInUtc).utcOffset(-siteSettingsData.TimeZoneOffset);

            setScheduledFleetLockdown({
                ...scheduledFleetLockdown,
                enableLockdownSFL: getScheduledFleetLockdownData?.IsEnabled,
                sflStartTime: new Date(2000, 0, 1, startDt.hour(), startDt.minute(), 0),
                sflEndTime: new Date(2000, 0, 1, endDt.hour(), endDt.minute(), 0),
                sflUnlockMode:
                    getScheduledFleetLockdownData?.UnlockGuardianMode === 2
                        ? "staged"
                        : "normal",
            });
            enableDisableLockdownState.set(getScheduledFleetLockdownData?.IsEnabled);
        }
    }, [getScheduledFleetLockdownData, siteSettingsData]);

    useEffect(() => {
        if (!enableDisableLockdownState.get()) {
            setSchedLockdownValidationMessage("");
            return;
        }
        const startTime = scheduledFleetLockdown.sflStartTime;
        const endTime = scheduledFleetLockdown.sflEndTime;
        if (isDefaultMidnight(startTime) && isDefaultMidnight(endTime)) {
            return;
        }
        if (isSameTime(startTime, endTime)) {
            setSchedLockdownValidationMessage("Start and End times cannot be the same time");
        } else {
            setSchedLockdownValidationMessage("");
        }
    }, [
        enableDisableLockdownState.get(),
        scheduledFleetLockdown.sflStartTime,
        scheduledFleetLockdown.sflEndTime
    ]);

    const isSameTime = (start, end) => {
        if (!start || !end) return false;

        return (
            start.getHours() === end.getHours() &&
            start.getMinutes() === end.getMinutes()
        );
    }


    const isDefaultMidnight = (time) => {
        return time && time.getHours() === 0 && time.getMinutes() === 0;
    }

    const cancelLockdownFunc = () => {
        redirectState.set(false);
        alertMsg.set(false);
        setSchedLockdownSaveButton(false);
        setSchedLockdownValidationMessage("");

        var startDt = moment.utc(getScheduledFleetLockdownData?.StartTimeInUtc).utcOffset(-siteSettingsData.TimeZoneOffset);
        var endDt = moment.utc(getScheduledFleetLockdownData?.EndTimeInUtc).utcOffset(-siteSettingsData.TimeZoneOffset);

        setScheduledFleetLockdown({
            ...scheduledFleetLockdown,
            sflEnableLockdown: getScheduledFleetLockdownData?.IsEnabled,
            sflStartTime: new Date(2000, 0, 1, startDt.hour(), startDt.minute(), 0),
            sflEndTime: new Date(2000, 0, 1, endDt.hour(), endDt.minute(), 0),
            sflUnlockMode:
                getScheduledFleetLockdownData?.UnlockGuardianMode === 2
                    ? "staged"
                    : "normal",
        });
        enableDisableLockdownState.set(getScheduledFleetLockdownData?.IsEnabled);
    }

    const handleSflNormalStagedBtn = (nameBtn, tableName) => {
        setSchedLockdownSaveButton(true);
        if (tableName === "SFL") {
            if (nameBtn === "normal") {
                setScheduledFleetLockdown({
                    ...scheduledFleetLockdown,
                    sflUnlockMode: "normal",
                });
            } else if (nameBtn === "staged") {
                setScheduledFleetLockdown({
                    ...scheduledFleetLockdown,
                    sflUnlockMode: "staged",
                });
            }
        }
    }

    const handleSflStartTime = (time) => {
        setSchedLockdownSaveButton(true);
        setScheduledFleetLockdown(prev => ({
            ...prev,
            sflStartTime: time
        }));

        validateLockdownTimes(
            enableDisableLockdownState.get(),
            time,
            scheduledFleetLockdown.sflEndTime
        );
    }

    const handleSflEndTime = (time) => {
        setSchedLockdownSaveButton(true);
        setScheduledFleetLockdown(prev => ({
            ...prev,
            sflEndTime: time
        }));

        validateLockdownTimes(
            enableDisableLockdownState.get(),
            scheduledFleetLockdown.sflStartTime,
            time
        );
    }

    const handleScheduledFleetLockdown = () => {
        if (
            enableDisableLockdownState.get() &&
            isSameTime(scheduledFleetLockdown.sflStartTime, scheduledFleetLockdown.sflEndTime)
        ) {
            setSchedLockdownValidationMessage("Start and End times cannot be the same time");
            return;
        }

        if (schedLockdownValidationMessage != "") {
            return;
        }

        setSchedLockdownSaveButton(false);
        // Convert the time values from the incoming site's local time to UTC
        var ms = moment.utc('2000-01-01T00:00:00');
        ms.hour(scheduledFleetLockdown.sflStartTime.getHours()).minute(scheduledFleetLockdown.sflStartTime.getMinutes());
        ms.utcOffset(siteSettingsData.TimeZoneOffset);
        // We don't care about the date component, so leave it at the default 1/1/2000
        // (Offsetting the time may have changed the date).
        ms.year(2000).month(0).date(1);

        // Do the same for the end time
        var me = moment.utc('2000-01-01T00:00:00');
        me.hour(scheduledFleetLockdown.sflEndTime.getHours()).minute(scheduledFleetLockdown.sflEndTime.getMinutes());
        me.utcOffset(siteSettingsData.TimeZoneOffset);
        me.year(2000).month(0).date(1);

        const payload = {
            IsEnabled: enableDisableLockdownState.value,
            StartTimeInUtc: ms.format('YYYY-MM-DDTHH:mm:ss.SSS'),
            EndTimeInUtc: me.format('YYYY-MM-DDTHH:mm:ss.SSS'),
            UnlockGuardianMode:
                scheduledFleetLockdown.sflUnlockMode === "normal" ? 1 : 2,
        };

        FleetLockdownLoader.set(true);
        dispatch(
            COMMON_SERVICES.putUpdateScheduleLockDownServices(payload, siteId.get())
        ).then(() => {
            dispatch(
                COMMON_SERVICES.getScheduledFleetLockdownServices(0, siteId.get())
            );
            FleetLockdownLoader.set(false);
            redirectState.set(false);
            alertMsg.set(false);
        });
    }

    const isTimeInvalid = isSameTime(
        scheduledFleetLockdown.sflStartTime,
        scheduledFleetLockdown.sflEndTime
    );

    const isBothDefaultMidnight =
        isDefaultMidnight(scheduledFleetLockdown.sflStartTime) &&
        isDefaultMidnight(scheduledFleetLockdown.sflEndTime);

    const validateLockdownTimes = (isEnabled, startTime, endTime) => {
        if (!isEnabled) {
            setSchedLockdownValidationMessage("");
            return;
        }

        if (isDefaultMidnight(startTime) && isDefaultMidnight(endTime)) {
            setSchedLockdownValidationMessage("");
            return;
        }

        if (isSameTime(startTime, endTime)) {
            setSchedLockdownValidationMessage(
                "Start and End times cannot be the same time"
            );
        } else {
            setSchedLockdownValidationMessage("");
        }
    }

    return (
        <>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Heading>
                        <h3>{t("Scheduled_Fleet_Lockdown")}</h3>
                    </Heading>
                </AccordionSummary>
                <AccordionDetails>
                    <WorkSection>
                        {FleetLockdownLoader.get() && (
                            <CenteredLoader className="innerSectionLoader">
                                <Loader />
                            </CenteredLoader>
                        )}
                        <div>
                            <CheckBoxWrapper className="no-side-border mb-22">
                                <CustomizedCheckbox
                                    disabled={
                                        getFeatureSetOption(
                                            siteSettingsData &&
                                            siteSettingsData !== null &&
                                            siteSettingsData?.Features,
                                            getFeaturesList().car_control
                                        ) ||
                                        isUserBasic(getUserRole && getUserRole?.Role) ||
                                        isUserReadOnly(getUserRole && getUserRole?.Role)
                                    }
                                    lockdownText="fleetlockdown"
                                    label={t("Enable_Lockdown")}
                                    name="Enable Lockdown SFL"
                                    width={15}
                                    height={15}
                                    activeButtonScheduled={setSchedLockdownSaveButton}
                                />
                            </CheckBoxWrapper>
                            <DateWrapper>
                                <StartEndDate>
                                    <p className="label">{t("Start")}</p>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <MobileTimePicker
                                            disabled={
                                                !enableDisableLockdownState.get() ||
                                                getFeatureSetOption(
                                                    siteSettingsData &&
                                                    siteSettingsData !== null &&
                                                    siteSettingsData?.Features,
                                                    getFeaturesList().car_control
                                                )
                                            }
                                            value={scheduledFleetLockdown.sflStartTime}
                                            onChange={(newValue) => {
                                                handleSflStartTime(newValue);
                                            }}
                                            renderInput={(params) => <TextField {...params} />}
                                        />
                                    </LocalizationProvider>
                                    <TimeIcon />
                                </StartEndDate>
                                <StartEndDate>
                                    <p className="label">{t("End")}</p>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <MobileTimePicker
                                            disabled={
                                                !enableDisableLockdownState.get() ||
                                                getFeatureSetOption(
                                                    siteSettingsData &&
                                                    siteSettingsData !== null &&
                                                    siteSettingsData?.Features,
                                                    getFeaturesList().car_control
                                                )
                                            }
                                            value={scheduledFleetLockdown.sflEndTime}
                                            onChange={(newValue) => {
                                                handleSflEndTime(newValue);
                                            }}
                                            renderInput={(params) => <TextField {...params} />}
                                        />
                                    </LocalizationProvider>
                                    <TimeIcon />
                                </StartEndDate>
                            </DateWrapper>

                            {schedLockdownValidationMessage && (
                                <p className="timeValidationMessage">
                                    {schedLockdownValidationMessage}
                                </p>
                            )}

                            <UnlockModeWrapper>
                                <p className="label">{t("Unlock_Mode")}</p>
                                <UnlockMode>
                                    <button
                                        style={
                                            getFeatureSetOption(
                                                siteSettingsData && siteSettingsData?.Features,
                                                getFeaturesList().car_control
                                            )
                                                ? { backgroundColor: "#d3d3d3" }
                                                : {}
                                        }
                                        disabled={getFeatureSetOption(
                                            siteSettingsData &&
                                            siteSettingsData !== null &&
                                            siteSettingsData?.Features,
                                            getFeaturesList().car_control
                                        )}
                                        onClick={() => handleSflNormalStagedBtn("normal", "SFL")}
                                        className={scheduledFleetLockdown.sflUnlockMode === "normal" ? "active" : "disabled"}
                                    >
                                        {t("Normal")}
                                    </button>
                                    <button
                                        style={
                                            getFeatureSetOption(
                                                siteSettingsData && siteSettingsData?.Features,
                                                getFeaturesList().car_control
                                            )
                                                ? { backgroundColor: "#d3d3d3" }
                                                : {}
                                        }
                                        disabled={getFeatureSetOption(
                                            siteSettingsData &&
                                            siteSettingsData !== null &&
                                            siteSettingsData?.Features,
                                            getFeaturesList().car_control
                                        )}
                                        onClick={() => handleSflNormalStagedBtn("staged", "SFL")}
                                        className={scheduledFleetLockdown.sflUnlockMode === "staged" ? "active" : "disabled"}
                                    >
                                        {t("Staged")}
                                    </button>
                                </UnlockMode>
                            </UnlockModeWrapper>
                            <ActionWrapper>
                                <Button
                                    style={
                                        (enableDisableLockdownState.get() && isTimeInvalid && !isBothDefaultMidnight) ||
                                            getFeatureSetOption(
                                                siteSettingsData && siteSettingsData?.Features,
                                                getFeaturesList().car_control
                                            )
                                            ? { backgroundColor: "#d3d3d3" }
                                            : {}
                                    }
                                    disabled={
                                        (enableDisableLockdownState.get() && isTimeInvalid && !isBothDefaultMidnight) ||
                                        getFeatureSetOption(
                                            siteSettingsData && siteSettingsData?.Features,
                                            getFeaturesList().car_control
                                        ) ||
                                        isUserBasic(getUserRole && getUserRole?.Role) ||
                                        isUserReadOnly(getUserRole && getUserRole?.Role)
                                    }
                                    onClick={handleScheduledFleetLockdown}
                                    className={schedLockdownSaveButton ? "active" : "disabled"}
                                >
                                    {t("Save")}
                                </Button>
                                <Button
                                    onClick={cancelLockdownFunc}
                                    style={
                                        getFeatureSetOption(
                                            siteSettingsData && siteSettingsData?.Features,
                                            getFeaturesList().car_control
                                        )
                                            ? { backgroundColor: "#d3d3d3" }
                                            : {}
                                    }
                                    disabled={
                                        getFeatureSetOption(
                                            siteSettingsData && siteSettingsData?.Features,
                                            getFeaturesList().car_control
                                        ) ||
                                        isUserBasic(getUserRole && getUserRole?.Role) ||
                                        isUserReadOnly(getUserRole && getUserRole?.Role)
                                    }
                                >
                                    {t("Cancel")}
                                </Button>
                            </ActionWrapper>
                        </div>
                        <div className="web-only"></div>
                        <div className="web-only"></div>
                        <div className="web-only"></div>
                    </WorkSection>
                </AccordionDetails>
            </Accordion>
        </>
    );
};